import { render, staticRenderFns } from "./AntiFraud.vue?vue&type=template&id=a88e24d0&scoped=true"
import script from "./AntiFraud.vue?vue&type=script&lang=js"
export * from "./AntiFraud.vue?vue&type=script&lang=js"
import style0 from "./AntiFraud.vue?vue&type=style&index=0&id=a88e24d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88e24d0",
  null
  
)

export default component.exports